function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "34",
  height: "24",
  viewBox: "0 0 34 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: ".5",
  y: ".5",
  width: "33",
  height: "23",
  rx: "3.5",
  fill: "#fff",
  stroke: "#D9D9D9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.839 19.3h2.596c4.052 0 7.282-3.215 7.408-7.187v-.063c-.063-4.034-3.356-7.312-7.408-7.25h-2.913c-3.862.127-6.902 3.405-6.775 7.313 0 3.909 3.166 7.124 7.092 7.187zm-5.826-7.25c0-3.278 2.723-5.989 6.016-5.989 3.292 0 6.015 2.711 6.015 5.99 0 3.277-2.723 5.988-6.015 5.988-3.293 0-6.016-2.71-6.016-5.989zm6.966 4.035V8.079c2.216.567 3.609 2.773 3.039 4.98a4.114 4.114 0 01-3.04 3.026zm-4.876-5.043a4.142 4.142 0 002.976 5.043V8.079a4.155 4.155 0 00-2.976 2.963z",
  fill: "#0079BE"
})));